module.exports = __webpack_public_path__ + "static/media/enter.9d06121e.svg";